import LinksFooterFW from '../../../../customized/fresh-watch/components/App/footer/LinksFooter/LinksFooter';
import LinksFooterFF from '../../../../customized/fours-fringand-fr/components/App/footer/LinksFooter/LinksFooter';
import { ToggleComponent } from '../../../../featureToggle';
import LinksFooter from './LinksFooter';
import LinksFooterMyBakery from '../../../../customized/my-bakery/components/auth/AuthLayout/LinksFooter';
export * from './LinksFooter';

export default ToggleComponent(LinksFooter, {
  styledComponentsVariants: {
    'fresh-watch': LinksFooterFW,
    'fours-fringand-fr': LinksFooterFF,
    'my-bakery': LinksFooterMyBakery,
  },
});
